import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { SearchCounteragentsPayload } from "../../payload/SearchCounteragents/SearchCounteragentsPayload";

const searchCounteragentsFetch = (state: FinanceState, action: PayloadAction<SearchCounteragentsPayload>) => {
    state.isLoading = true;
}

export default searchCounteragentsFetch;